import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ContactHero from "./components/ContactHero";
import ContactChannels from "./components/ContactChannels";
import ContactFaq from "./components/ContactFaq";

export default function ContactPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg-base)" }}>
      <Navbar />
      <main>
        <ContactHero />
        <ContactChannels />
        <ContactFaq />
      </main>
      <Footer />
    </div>
  );
}